import { useFormContext } from 'react-hook-form';
import type { DatovkaApiType } from '@gov-nx/api/types/databoxTypes';
import { useRecipientSearchAutocomplete } from '@gov-nx/core/hooks/DataBox/useRecipientSearchAutocomplete';
import { useLocale } from '@gov-nx/core/service/translations/useLocale';
import type { DataBoxMessageFormInputs } from '@gov-nx/module/data-box/providers/MessageFormContext.types';
import { PageCode } from '@gov-nx/module/page/definitions/codes';
import { FormAutocomplete } from '@gov-nx/ui/web/Form/FormAutocomplete';
import { DataBoxListItem } from './DataBoxListItem';

export const RecipientAutocomplete = () => {
	const { t: tn } = useLocale(PageCode['datove-schranky']);
	const { searchCallback } = useRecipientSearchAutocomplete();
	// TODO: NAKITPO-5495 remove the wrapper onBlur once the design system GovFormAutocomplete forwards onBlur to its input (still overridden in @gov-design-system-ce/react 3.10.0)
	const { trigger } = useFormContext<DataBoxMessageFormInputs>();

	const getDataBoxListItem = (dataBox: DatovkaApiType, searchValue: string) => (
		<DataBoxListItem
			dataBox={dataBox}
			searchValue={searchValue}
		/>
	);

	return (
		<div
			className="gov-form-control ds-new-message ds-recipient pr-0.5"
			onBlur={() => trigger('recipientAutocomplete')}>
			<FormAutocomplete
				label={{
					children: `${tn('nova-zprava.komu')}:`,
					isRequired: true,
				}}
				field={{
					name: 'recipientAutocomplete',
					placeholder: tn('nova-zprava.vyhledejte'),
					messageEmpty: tn('nova-zprava.zadny-vysledek'),
					templateResolver: (item) => getDataBoxListItem(item, ''), // @TODO SMID: provide this second argument fom DS
					valueResolver: () => '',
					keyResolver: (item: DatovkaApiType) => item.datovaSchrankaId || '',
					searchCallback,
				}}
			/>
		</div>
	);
};
